var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('COProfiles',{staticClass:"profiles-in-steper",attrs:{"preselected-filters":{
  status: ['active'],
},"show-select":"","show-actions":false,"hide-unrelated":true},on:{"selected":_vm.enterSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }